"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.ApiFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M5.11908 1.81586C5.41198 1.52297 5.88685 1.52297 6.17974 1.81586L7.5826 3.21871L7.59405 3.22993L7.77087 3.40675L8.65473 2.52289C8.94762 2.23 9.4225 2.23 9.71539 2.52289C10.0083 2.81579 10.0083 3.29066 9.71539 3.58355L8.83153 4.46741L11.4833 7.11915L12.3671 6.23529C12.66 5.9424 13.1349 5.9424 13.4278 6.23529C13.7207 6.52819 13.7207 7.00306 13.4278 7.29596L12.5439 8.17981L12.8974 8.53323L12.9085 8.54458L14.3115 9.94759C14.6044 10.2405 14.6044 10.7154 14.3115 11.0082C14.0186 11.3011 13.5437 11.3011 13.2508 11.0082L12.3669 10.1243L10.5993 11.892C9.02261 13.4686 6.56711 13.6308 4.80971 12.3784L3.52823 13.6599C3.23533 13.9528 2.76046 13.9528 2.46757 13.6599C2.17467 13.367 2.17467 12.8921 2.46757 12.5992L3.74903 11.3178C2.49651 9.56035 2.6586 7.10472 4.23529 5.52803L6.00294 3.76038L5.11908 2.87652C4.82619 2.58363 4.82619 2.10875 5.11908 1.81586Z", fill: colors[0] }));
    },
    name: 'api_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M5.11908 1.81586C5.41198 1.52297 5.88685 1.52297 6.17974 1.81586L7.5826 3.21871L7.59405 3.22993L7.77087 3.40675L8.65473 2.52289C8.94762 2.23 9.4225 2.23 9.71539 2.52289C10.0083 2.81579 10.0083 3.29066 9.71539 3.58355L8.83153 4.46741L11.4833 7.11915L12.3671 6.23529C12.66 5.9424 13.1349 5.9424 13.4278 6.23529C13.7207 6.52819 13.7207 7.00306 13.4278 7.29596L12.5439 8.17981L12.8974 8.53323L12.9085 8.54458L14.3115 9.94759C14.6044 10.2405 14.6044 10.7154 14.3115 11.0082C14.0186 11.3011 13.5437 11.3011 13.2508 11.0082L12.3669 10.1243L10.5993 11.892C9.02261 13.4686 6.56711 13.6308 4.80971 12.3784L3.52823 13.6599C3.23533 13.9528 2.76046 13.9528 2.46757 13.6599C2.17467 13.367 2.17467 12.8921 2.46757 12.5992L3.74903 11.3178C2.49651 9.56035 2.6586 7.10472 4.23529 5.52803L6.00294 3.76038L5.11908 2.87652C4.82619 2.58363 4.82619 2.10875 5.11908 1.81586Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
